import { supabase } from "./supabase";

export async function optimiseCVWithAI(cvText: string, jobDescription: string, targetJobTitle?: string, targetCompany?: string) {
  try {
    const { data, error } = await supabase.functions.invoke("optimise", {
      body: { 
        cv: cvText, 
        jobDescription, 
        targetJobTitle, 
        targetCompany 
      },
    });
    
    if (error) {
      console.error("Supabase Function Error:", error);
      throw new Error(error.message || "Failed to communicate with optimization service");
    }

    return data; // Now includes { result, candidateFirstName, candidateLastName }
  } catch (error) {
    console.error("AI Optimization Error:", error);
    throw error;
  }
}
